/**
 * Normalize the share-recipients endpoint payload to a user array.
 *
 * `GET /api/document-share/users/<docId>/` returns
 * `{ users: [...], existing_shares: [...] }`. The Inbox task/message
 * modals shipped expecting a bare array (or DRF `results`), so every
 * teammate search showed "No matching teammates" — the list was never
 * parsed (Matthew hit this live, 2026-07-17). Accept all three shapes
 * so a future backend pagination change can't silently blank the
 * picker again.
 */
export const normalizeShareRecipients = (response) => {
  const data = response?.data;
  if (Array.isArray(data?.users)) return data.users;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data)) return data;
  return [];
};
